<script>

    export default {
        async mounted () {         
          this.loadIndustries();
          this.industryTypes = await this.$store.getters.industryTypes
          this.opportunityTypes = await this.$store.getters.opportunityTypes 
        },
        data() {
            return {
                industries: "",
                active_tab: 'all',
                filterOpportunityTypes: [],
                filteredIndustries: [],
                opportunityTypes: [],
                industryTypes: []
            }
        },  
        computed: {
          // a computed getter
          displayCount: function () {
            // `this` points to the vm instance
            return this.filteredIndustries.length
          }
        },
        methods: {  
          filterOpportunities() {
            console.log("Current set of filters: "  + this.filterOpportunityTypes)
            return this.industries.filter( company => {
              var filterOpportunityTypes = this.filterOpportunityTypes; //["internship"]
              console.log("Current set of filters: "  + this.filterOpportunityTypes)
              if ( company.businessOpportunities ) {

                var types = []
                Object.keys(company.businessOpportunities).forEach( oppKey => {
                  var opp = company.businessOpportunities[oppKey]
                  types.push(opp.type_code)
                })
                //console.log(types)


                var intersection = filterOpportunityTypes.filter(x => types.includes(x));
                //console.log(intersection)
                
                var filterOpportunitiesIntersects = (intersection.length != 0 || filterOpportunityTypes.length == 0 )
                
                //console.log("returning " + filterOpportunitiesIntersects)
                return filterOpportunitiesIntersects;
              } else {
                return filterOpportunityTypes.length == 0
              }
            })

          }, 
          filter() {
            this.filteredIndustries = this.filterOpportunities()
          },           
          filterIndustry( industryType ) {
            if( industryType == '' ) {
              this.active_tab = 'all'
            } else {
              this.active_tab = industryType.id
            }
          },   
          loadIndustries() {
            var ref = this.$firebase.ref('Company/');
            ref.once('value', function(snapshot) {

              // create the array of industries
              var industries = [];  
              snapshot.forEach(function(e) {
                  var item = e.val();
                  item.key = e.key;

                  industries.push(item);
              });  
              
              // filter out those with no data
              this.industries = industries.filter( e => e.profileUpdated && e.location != undefined)

              // sort alphabetically
              this.industries.sort( (a,b) => {
                console.log("sort " + a.name)
                if ( a.name < b.name ) { 
                  return -1
                } else {
                  return 1
                }
                return 0
              })

              // set filtered list
              this.filteredIndustries = this.industries

            }.bind(this));
            
          }      
        }
        
    }
</script>

<template lang="pug">
.foo
    #search-hdr.row
      .col.s11.offset-s1.m5.offset-m1
        h5 FILTER YOUR SEARCH
        p
          | Choose a tab below to filter your search. Refer to the symbol legend to learn what specific opportunities each company is offering. 
        | Showing 
        b {{displayCount}} 
        | Industries
      #legend.col.s11.offset-s1
        //- .row.legend-row
          //- .col.s1.search-icon.student-icon
          //- .col.s11  {{oppType}}
        .filter-courses
          br 
          | Opportunity Types
          .course-check-container
            .course-check(v-for="(oppType, key) in opportunityTypes")
              input(type="checkbox" v-model="filterOpportunityTypes" :value="key" @change="filter()")
              label {{oppType}}          
    .row#search-container 
      #search-div.col.s10.offset-s1
        p 
          | Filter by Industry Type
          select.industry_type_select(v-model="active_tab")
            option( value="all" ) All
            option(
              v-for="industryType in industryTypes"
              :value="industryType.id"
            ) {{industryType.name}}        
        //- a#template-btn.form_btns.all-btns( 
        //-   @click="filterIndustry('')"
        //-   v-bind:class="{ 'btn-active' : active_tab == 'all' }" ) All
        //- a#template-btn.form_btns( 
        //-   v-for="industryType in industryTypes" 
        //-   @click="filterIndustry(industryType)"
        //-   :class="{ 'btn-active' : active_tab == industryType.id }"
        //-   :id="industryType.id") {{industryType.name}}
        #template-table.form_tables
          table#search-tbl.striped
            thead#tbl-hdr
              tr
                th.com_th Company
                th.loc_th Location
                th.opps Opportunity Types Available
            tbody
              tr(v-for="industry in filteredIndustries" v-if="active_tab == industry.industry || active_tab == 'all'")
                td
                  p.tbl-cmp
                    router-link(:to="'/educator/viewIndustry/' + industry.key") {{industry.name}}
                td {{industry.location.city}}, {{industry.location.state}}
                td
                  .opp(v-for="opp in industry.businessOpportunities") {{ opportunityTypes[opp.type_code] }} 

      br
      br
      br
    


</template>

<style lang="sass" scoped>

.industry_type_select
  display: block !important
  width: 50%

@media screen and (max-width:700px)
  .industry_type_select  
    width: 100%

input
  opacity: 100 !important
  position: relative !important
  pointer-events: all !important

label
  padding-left: 5px


#search-tbl
  top: .5em;
  position: relative;

#tbl-hdr 
    background-color: #d3d3d3;
    border-top: 1px solid;
    border-bottom: 1px solid;

.form_btns:hover 
    background-color: #dc7e33;
    color: #fff;
    transition: .5s;
    cursor: pointer;

.form_btns
    margin: 0 -1px 0px 0 !important;
    color: #dc7e33;
    border: 1px solid #dc7e33;
    /* border-bottom: none; */
    padding: 5px;
    font-size: 12px;
    -webkit-transition: .5s;
    transition: .5s;
    display: block;
    width: 120px;
    float: left;
    height: 50px;


.btn-active
  background-color: #dc7e33;
  color: #fff;
  transition: .5s;  

.student-icon 
  background: url('~@/assets/svg/Asset10.svg') center no-repeat;
  background-size: contain;


.class-icon 
  background: url('~@/assets/svg/Asset9.svg') center no-repeat;
  background-size: contain;


.facility-icon 
  background: url('~@/assets/svg/Asset8.svg') center no-repeat;
  background-size: contain;


.student-icon-null 
  background: url('~@/assets/svg/Asset13.svg') center no-repeat;
  background-size: contain;


.class-icon-null 
  background: url('~@/assets/svg/Asset12.svg') center no-repeat;
  background-size: contain;


.facility-icon-null 
  background: url('~@/assets/svg/Asset11.svg') center no-repeat;
  background-size: contain;


.search-icon 
  height: 20px;
  margin-left: -15px !important;
  margin-right: 5px;
  padding: 0 !important;
  width: 20px;


.legend-row 
  padding-bottom: .5em;




#company-img 
  padding: 0;

#name 
  margin-top: 0;


#search-hdr h5 
  padding-top: 1em;


#search-hdr p 
  padding-bottom: 1em;


.opps-container, .intro-container 
  padding: 0 1em 0 1em;


.input-div.opp-title 
  color: #000 !important;
  font-weight: normal !important;


.opp-title 
  color: #1589FF;
  font-weight: bold;


.opp-details 
  font-size: 14px;



</style>